// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"535":"login","940":"request"}[chunkId] + "." + {"535":"297e7283","940":"4864d8a9"}[chunkId] + ".js";
};